import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';
import { useI18n } from '../i18n';
import { Container as BaseContainer, PrimaryButton } from './GlobalStyle';

const FooterSection = styled.footer`
  background: ${({ theme }) => theme.colors.bgSubtle};
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: 2.5rem 2rem;
  margin-top: 2rem;
`;

const Container = styled(BaseContainer)`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr auto;
  align-items: center;
  gap: 1rem;
  @media (max-width: 980px) {
    grid-template-columns: 1fr;
    row-gap: 1.2rem;
  }
`;

const BrandImg = styled.img`
  height: 28px;
`;

const Links = styled.nav`
  display: flex;
  gap: 1.25rem;
  flex-wrap: wrap;
  a {
    color: ${({ theme }) => theme.colors.muted};
    font-weight: 500;
    transition: color ${({ theme }) => theme.transition.base};
    &:hover {
      color: ${({ theme }) => theme.colors.brand};
    }
  }
`;

const Buttons = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const ContactButton = styled(PrimaryButton)`
  padding: 0.5rem 1rem;
  min-height: 40px;
  font-size: 0.95rem;
`;

const Socials = styled.div`
  display: flex;
  gap: 0.8rem;
  a {
    display: inline-flex;
    color: ${({ theme }) => theme.colors.muted};
    font-size: 1.25rem;
    border-radius: 4px;
    transition: color ${({ theme }) => theme.transition.base},
      transform ${({ theme }) => theme.transition.base};
    &:hover {
      color: ${({ theme }) => theme.colors.brand};
      transform: translateY(-2px);
    }
  }
`;

const Copyright = styled.div`
  color: ${({ theme }) => theme.colors.muted};
  font-size: 0.9rem;
  grid-column: 1 / -1;
  text-align: center;
  margin-top: 0.5rem;
`;

const Footer = () => {
  const { t } = useI18n();
  return (
    <FooterSection>
      <Container>
        <BrandImg src="/logo-nb.png" alt="Berrik" />
        <Links aria-label="Footer">
          <Link to="/solutions">{t('nav.solutions')}</Link>
          <Link to="/about">{t('nav.about')}</Link>
          <Link to="/updates">{t('nav.updates')}</Link>
        </Links>
        <Buttons>
          <ContactButton to="/contact">{t('footer.contactUs')}</ContactButton>
        </Buttons>
        <Socials>
          <a href="https://instagram.com/berrik_chile" target="_blank" rel="noreferrer" aria-label="Instagram"><FaInstagram aria-hidden="true" /></a>
          <a href="https://linkedin.com/company/berrik" target="_blank" rel="noreferrer" aria-label="LinkedIn"><FaLinkedin aria-hidden="true" /></a>
        </Socials>
        <Copyright>© {new Date().getFullYear()} Berrik. {t('footer.rights')}</Copyright>
      </Container>
    </FooterSection>
  );
};

export default Footer;
